import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Card } from '../../../../../CommonComponents/OPL/Card/Card';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { WidgetId } from '../../../../api/useWidgetsQuery';
import { TabSlug } from '../../../../types';
import { GroupSelection } from '../../../GroupSelection/GroupSelection';
import { PerformanceChart } from '../../../PerformanceChart/PerformanceChart';

interface Props {
  title: string;
  id: WidgetId;
}

export const PerformanceChartCard = React.memo(({ title, id }: Props) => {
  return (
    <Box>
      <GroupSelection id={id} tabSlug={TabSlug.Performance} />

      <Card>
        <Text variant="cardTitle" px="16" pt="12" pb="4">
          {title}
        </Text>

        <Box>
          <PerformanceChart title={title} />
        </Box>
      </Card>
    </Box>
  );
});
